@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence' [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'>
      <mat-label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.readOnly) {
        <input readonly matInput
          [formControlName]='inputService.formControlKey'
          [matDatepickerFilter]="dateFilterBinded"
          [matDatepicker]="dp3" >
      }
      @if (!inputService.inputConfig.readOnly && !manualInput) {
        <input
          [required]='inputService.inputConfig.required'
          matInput
          [matDatepickerFilter]="dateFilterBinded"
          [matDatepicker]="dp3"
          [placeholder]="inputService.inputConfig.placeholder | translate"
          [formControlName]='inputService.formControlKey'
          (click)='dp3.open()' readonly>
      }
      @if (!inputService.inputConfig.readOnly && manualInput) {
        <input
          [required]='inputService.inputConfig.required'
          matInput
          [matDatepickerFilter]="dateFilterBinded"
          [matDatepicker]="dp3"
          [placeholder]="inputService.inputConfig.placeholder | translate"
          [formControlName]='inputService.formControlKey'>
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-datepicker-toggle matSuffix [for]="dp3">
          <mat-icon matDatepickerToggleIcon>event</mat-icon>
        </mat-datepicker-toggle>
      }
      <mat-datepicker #dp3></mat-datepicker>
      @if (inputService.control.value && inputService.inputConfig.clearable) {
        <mat-icon matSuffix (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}